import React, { useState, useEffect } from 'react';
import SelectBox from '../common/SelectBox';
import AdminNavigation from './AdminNavigation';
import Input from '../common/Input';
import { format } from 'date-fns';
import { getVendorAccounts } from '../service/vendorService';
import { toast } from 'react-toastify';
import DataTable from '../common/DataTable';
import subDays from 'date-fns/subDays';
import { getEndDailyHistoryByVendorAccountId } from '../service/dailyHistory';
import { CSVLink } from 'react-csv';
import { isAdmin } from '../service/authService';

const EndDayHistory = () => {
   const [startDate, setStartDate] = useState(subDays(new Date(), 7));
   const [endDate, setEndDate] = useState(new Date());
   const [accounts, setAccounts] = useState([{ vendorAccountName: 'ALL', vendorAccountId: 0 }]);
   const [account, setAccount] = useState({});
   const [items, setItems] = useState([]);
   const user = JSON.parse(localStorage.getItem('user'));
   const exportHeaders = [
      { label: 'Reference', key: 'recordId' },
      { label: 'Vendor Account', key: 'vendorAccountId.vendorAccountName' },
      { label: 'Opening Balance', key: 'openingBalance' },
      { label: 'Transactions', key: 'transactions' },
      { label: 'Total Amount', key: 'transactionAmount' },
      { label: 'Recharge Amount', key: 'rechargeAmount' },
      { label: 'Closing Balance', key: 'closingBalance' },
      { label: 'Time', key: 'recordDatetime' },
   ];
   const columns = [
      {
         columnCaption: 'Id',
         columnKey: 'recordId',
         content: (item) => <span style={{ fontSize: 10 }}>{item.recordId}</span>,
      },
      {
         columnCaption: 'Vendor Account',
         columnKey: 'vendorAccountId.vendorAccountName',
         content: (item) => <span style={{ fontSize: 10 }}>{item.vendorAccountId.vendorAccountName}</span>,
      },
      {
         columnCaption: 'Opening Balance',
         columnKey: 'openingBalance',
         content: (item) => <span style={{ fontSize: 10 }}>{formatNumber(item.openingBalance)}</span>,
      },
      {
         columnCaption: 'Sales Count',
         columnKey: 'transactions',
         content: (item) => <span style={{ fontSize: 10 }}>{formatNumber(item.transactions)}</span>,
      },
      {
         columnCaption: 'Sales Total',
         columnKey: 'transactionAmount',
         content: (item) => <span style={{ fontSize: 10 }}>{formatNumber(item.transactionAmount)}</span>,
      },
      {
         columnCaption: 'Recharge',
         columnKey: 'rechargeAmount',
         content: (item) => <span style={{ fontSize: 10 }}>{formatNumber(item.rechargeAmount)}</span>,
      },
      {
         columnCaption: 'Closing Balance',
         columnKey: 'closingBalance',
         content: (item) => <span style={{ fontSize: 10 }}>{formatNumber(item.closingBalance)}</span>,
      },
      {
         columnCaption: 'Time',
         columnKey: 'recordDatetime',
         content: (item) => <span style={{ fontSize: 10 }}>{item.recordDatetime}</span>,
      },
   ];

   const formatNumber = (input) => {
      return new Intl.NumberFormat('en-US', {}).format(input);
   };

   const fetchVendorAccounts = () => {
      getVendorAccounts()
         .then((response) => {
            const vendorAccounts = response.data.data;
            const checkAdmin = isAdmin();
            if (checkAdmin) {
               setAccounts((prevState) => {
                  return prevState.concat(vendorAccounts);
               });
            } else {
               const newAccounts = user.accounts;
               setAccounts(newAccounts);
            }
         })
         .catch((error) => {
            toast.error('Error occurs while fetching vendor accounts');
         });
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      if (account.vendorAccountId >= 0) {
         getEndDailyHistoryByVendorAccountId({
            vendorAccountId: account.vendorAccountId,
            startDate: format(startDate, 'yyyy-MM-dd'),
            endDate: format(endDate, 'yyyy-MM-dd'),
         })
            .then((response) => {
               const endDailyHistory = response.data.data;
               setItems(endDailyHistory);
            })
            .catch((error) => {
               console.dir(error);
            });
      }
   };

   useEffect(fetchVendorAccounts, []);

   useEffect(() => {
      const fetchEndDailyHistory = () => {
         if (account.vendorAccountId >= 0) {
            getEndDailyHistoryByVendorAccountId({
               vendorAccountId: account.vendorAccountId,
               startDate: format(startDate, 'yyyy-MM-dd'),
               endDate: format(endDate, 'yyyy-MM-dd'),
            })
               .then((response) => {
                  const endDailyHistory = response.data.data;
                  setItems(endDailyHistory);
               })
               .catch((error) => {
                  console.dir(error);
               });
         }
      };
      fetchEndDailyHistory();
   }, [account, endDate, startDate]);

   return (
      <div className='container'>
         <div className='row'>
            <div className='col-md-2'>
               <AdminNavigation />
            </div>
            <div className='col-md-10'>
               <form className='form' onSubmit={handleSubmit}>
                  <div className='form-row'>
                     <div className='form-group col-md-3'>
                        <label htmlFor='startDate'>Start Date</label>
                        <Input
                           type='date'
                           selected={startDate}
                           onChange={(date) => setStartDate(date)}
                           dateFormat='dd/MM/yyyy'
                           id='startDate'
                           name='startDate'
                           className='form-control form-control-sm custom-input'
                        />
                     </div>
                     <div className='form-group col-md-3'>
                        <label htmlFor='endDate'>End Date</label>
                        <Input
                           id='endDate'
                           name='endDate'
                           label='End Date'
                           dateFormat='dd/MM/yyyy'
                           type='date'
                           selected={endDate}
                           onChange={(date, e) => setEndDate(date)}
                           className='form-control form-control-sm custom-input'
                        />
                     </div>
                  </div>
                  <div className='form-row'>
                     <div className='form-group col-md-6'>
                        <SelectBox
                           name='vendorAccount'
                           label='Vendor Account Id'
                           getOptionLabel={({ vendorAccountName }) => vendorAccountName}
                           getOptionValue={(option) => option}
                           value={account}
                           options={accounts}
                           onChange={(selected) => setAccount(selected)}
                           placeholder={'Search By ...'}
                        />
                     </div>
                  </div>
                  <button className='btn btn-primary btn-sm search-button mr-2' onClick={handleSubmit}>
                     Search
                  </button>
               </form>
               <div className='mt-3 form'>
                  <div className='d-flex justify-content-between'>
                     <div className='mb-2'>
                        <CSVLink
                           data={items}
                           headers={exportHeaders}
                           filename={`endofday_${account.vendorAccountName}.csv`}
                           target='_blank'
                           className='btn-link-custom font-italic font-weight-normal'
                        >
                           Export CSV
                        </CSVLink>
                     </div>
                  </div>
                  <DataTable items={items} fontStyle={{ fontSize: 10 }} pageSize={60} columns={columns}></DataTable>
               </div>
            </div>
         </div>
      </div>
   );
};

export default EndDayHistory;
